import { render, staticRenderFns } from "./ProgrammeForm.vue?vue&type=template&id=b7eedbd4&scoped=true&"
import script from "./ProgrammeForm.vue?vue&type=script&lang=js&"
export * from "./ProgrammeForm.vue?vue&type=script&lang=js&"
import style0 from "./ProgrammeForm.vue?vue&type=style&index=0&id=b7eedbd4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7eedbd4",
  null
  
)

export default component.exports